import { jsx as _jsx } from "preact/jsx-runtime";
import { UIPlugin } from '@uppy/core';
import { defaultStorage, RequestClient, } from '@uppy/core/companion-client';
import { GoogleDriveIcon, GooglePickerView } from '@uppy/core/provider-views';
import packageJson from '../package.json' with { type: 'json' };
import locale from './locale.js';
export default class GoogleDrivePicker extends UIPlugin {
    static VERSION = packageJson.version;
    static requestClientId = GoogleDrivePicker.name;
    type = 'acquirer';
    icon = GoogleDriveIcon;
    storage;
    defaultLocale = locale;
    requestClientId = GoogleDrivePicker.requestClientId;
    constructor(uppy, opts) {
        super(uppy, opts);
        this.id = this.opts.id || 'GoogleDrivePicker';
        this.storage = this.opts.storage || defaultStorage;
        this.defaultLocale = locale;
        this.i18nInit();
        this.title = this.i18n('pluginNameGoogleDrivePicker');
        this.setPluginState({
            loading: false,
            accessToken: undefined,
        });
        this.getPluginState = this.getPluginState.bind(this);
        this.setPluginState = this.setPluginState.bind(this);
        const requestClient = new RequestClient(uppy, {
            companionUrl: this.opts.companionUrl,
            companionHeaders: this.opts.companionHeaders,
            companionCookiesRule: this.opts.companionCookiesRule,
            companionKeysParams: this.opts.companionKeysParams,
        });
        this.uppy.registerRequestClient(GoogleDrivePicker.requestClientId, requestClient);
    }
    install() {
        const { target } = this.opts;
        if (target) {
            this.mount(target, this);
        }
    }
    uninstall() {
        this.unmount();
    }
    render = () => (_jsx(GooglePickerView, { getPluginState: this.getPluginState, setPluginState: this.setPluginState, storage: this.storage, pickerType: "drive", uppy: this.uppy, i18n: this.i18n, clientId: this.opts.clientId, apiKey: this.opts.apiKey, appId: this.opts.appId, requestClientId: GoogleDrivePicker.requestClientId, companionUrl: this.opts.companionUrl }));
}
